export const TODOS_ADD_TODO_REQUEST = 'TODOS_ADD_TODO_REQUEST'
export const TODOS_ADD_TODO_SUCCESS = 'TODOS_ADD_TODO_SUCCESS'
export const TODOS_ADD_TODO_ERROR = 'TODOS_ADD_TODO_ERROR'
export const TODOS_FETCH_TODOS = 'TODOS_FETCH_TODOS'
export const TODOS_FETCH_TODO = 'TODOS_FETCH_TODO'
export const TODOS_ADD_TODO_MODAL_CANCEL = 'TODOS_ADD_TODO_MODAL_CANCEL'
export const TODOS_ADD_TODO_MODAL_OPEN = 'TODOS_ADD_TODO_MODAL_OPEN'
export const TODOS_TOGGLE_LIST = 'TODOS_TOGGLE_LIST'
export const TODOS_CLOSE_LIST = 'TODOS_CLOSE_LIST'